import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "redux/store";
import Root from "root";
import { HelmetProvider } from "react-helmet-async";
import { initGA } from "analytics/ga4";

initGA();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <HelmetProvider>
        <Root />
      </HelmetProvider>
    </React.StrictMode>
  </Provider>
);
